import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CompanyContact } from '../_models/companyContact';

@Injectable()
export class CompanyContactService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getCompanyContacts(): Observable<CompanyContact[]> {
    return this.http
      .get<CompanyContact[]>(this.apiBaseUrl + 'api/private/v1/companyContacts')
      .pipe(map((response) => response));
  }

  getCompanyContact(id: number): Observable<CompanyContact> {
    return this.http
      .get<CompanyContact>(this.apiBaseUrl + 'api/private/v1/companyContacts/' + id)
      .pipe(map((response) => response));
  }

  saveCompanyContact(companyContactItem): Observable<CompanyContact> {
    const companyContact = { ...companyContactItem };
    delete companyContact.lastUpdated;
    delete companyContact.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    companyContact.companyId = companySelected ? companySelected.id : null;

    if (companyContact.user != null && companyContact.user.id != null) {
      companyContact.user = { id: companyContact.user.id };
    }
    if (companyContact.id) {
      return this.http
        .put<CompanyContact>(
          this.apiBaseUrl + 'api/private/v1/companyContacts/' + companyContact.id,
          companyContact
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<CompanyContact>(this.apiBaseUrl + 'api/private/v1/companyContacts/', companyContact)
        .pipe(map((response) => response));
    }
  }

  deleteCompanyContact(id: number): Observable<CompanyContact> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/companyContacts/' + id).pipe(
      map((response) => {
        return { id } as CompanyContact;
      })
    );
  }
}
